export default {
  common: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '新增',
    close: '关闭',
    search: '搜索',
    submit: '提交',
    confirm: '确认',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    view: '查看',
    back: '返回',
    print: '打印',
    send: '发送',
    create: '创建',
    reset: '重置',
    all: '全部',
    unknown: '未知错误',
    pleaseLogin: '请先登录',
    name: '姓名',
    email: '邮箱',
    phone: '手机号',
    status: '状态',
    action: '操作',
    grade: '年级',
    description: '描述',
    remark: '备注',
    date: '日期',
    time: '时间',
    class: '班级',
    student: '学生',
    teacher: '老师',
    campus: '校区',
    role: '角色',
    notSet: '未设置',
    notAssigned: '未分配',
    active: '活跃',
    inactive: '停用',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    yes: '确定',
    none: '无',
    fetchFailed: '获取数据失败',
    loadMore: '加载更多',
  },
  nav: {
    dashboard: '仪表盘',
    students: '学生管理',
    classes: '班级管理',
    teachers: '老师管理',
    campuses: '校区管理',
    absences: '请假管理',
    makeup: '补课管理',
    profile: '个人中心',
    auditLog: '操作日志',
    dataManagement: '数据管理',
    logout: '退出登录',
    home: '首页',
    mine: '我的',
  },
  roles: {
    admin: '管理员',
    teacher: '老师',
    parent: '家长',
  },
  login: {
    title: '瀚文书院',
    subtitle: '瀚文书院管理系统',
    emailPlaceholder: '邮箱地址',
    passwordPlaceholder: '密码',
    loginBtn: '登录',
    loginFailed: '登录失败，请重试',
    emailRequired: '请输入邮箱地址',
    emailInvalid: '请输入有效的邮箱地址',
    passwordRequired: '请输入密码',
    passwordMin: '密码长度至少6位',
    helpText: '如需帮助，请联系班级老师',
    guideLink: '查看家长使用说明',
    forgotPassword: '忘记密码？',
  },
  dashboard: {
    adminTitle: '欢迎回来，{{name}}！',
    adminSubtitle: '数据概览与快捷入口',
    teacherTitle: '你好，{{name}}！',
    teacherSubtitle: '今日有 {{count}} 节课程',
    teacherClassCount: '您负责 {{count}} 个班级',
    systemOverview: '系统概览',
    welcomeBack: '欢迎回来，{{name}}',
    totalStudents: '学生总数',
    totalClasses: '班级总数',
    quickAccess: '快捷入口',
    campusOverview: '校区概览',
    teacherOverview: '老师概览',
    pendingAbsences: '待审核请假',
    makeupClasses: '补课安排',
    recentAbsences: '最近缺席报告',
    upcomingMakeup: '即将开始的补课',
    noCampuses: '暂无校区',
    noTeachers: '暂无老师',
    noAbsences: '暂无请假记录',
    noMakeup: '暂无补课安排',
    todaySchedule: '今日课表 ({{count}})',
    recentSchedule: '最近课表 ({{count}})',
    myClasses: '我的班级',
    viewAll: '查看全部',
    pendingLeave: '待审批请假',
    noPendingLeave: '暂无待审批的请假申请',
    checkIn: '签到',
    details: '详情',
    noClassesToday: '今日暂无课程',
    noClasses: '暂无班级',
    students_unit: '名学生',
    people_unit: '人',
    items_unit: '条',
    count_unit: '个',
    classes_unit: '节',
    approve: '批准',
    reject: '拒绝',
    sick: '生病',
    personalLeave: '事假',
    schoolActivity: '学校活动',
    session: '节',
    viewAttendance: '查看出勤',
    recentAbsencesMakeups: '最近请假/补课',
    noRecentRecords: '暂无最近记录',
    makeup: '补课',
  },
  classes: {
    title: '班级管理',
    subtitle: '当前共有 {{count}} 个班级',
    addClass: '添加班级',
    editClass: '编辑班级',
    searchPlaceholder: '搜索班级...',
    name: '班级名称',
    level: '班级级别',
    levelXiucai: '秀才班',
    levelJuren: '举人班',
    levelJinshi: '进士班',
    levelZhuangyuan: '状元班',
    levelYangXiucai: '洋秀才班',
    levelYangJuren: '洋举人班',
    levelYangJinshi: '洋进士班',
    levelYangZhuangyuan: '洋状元班',
    levelOther: '其他',
    teacher: '教师',
    campus: '校区',
    studentCount: '学生数',
    schedule: '上课时间',
    description: '班级描述',
    instructor: '授课教师',
    location: '所在校区',
    dayOfWeek: '上课星期',
    firstSessionDate: '第一节课日期',
    startTime: '开始时间',
    endTime: '结束时间',
    totalSessions: '总节数',
    capacity: '班级容量',
    noData: '暂无班级数据',
    fullBadge: '已满员',
    deleteConfirm: '确定要删除这个班级吗？',
    deleteSuccess: '班级删除成功',
    deleteFailed: '删除班级失败',
    saveSuccess: '班级信息更新成功',
    addSuccess: '班级添加成功',
    saveFailed: '保存班级信息失败',
    namePlaceholder: '请输入班级名称',
    nameRequired: '请输入班级名称',
    levelRequired: '请选择班级级别',
    levelPlaceholder: '请选择班级级别',
    teacherRequired: '请选择授课教师',
    teacherPlaceholder: '请选择授课教师',
    campusRequired: '请选择所在校区',
    campusPlaceholder: '请选择所在校区',
    dayRequired: '请选择上课星期',
    dayPlaceholder: '请选择上课星期',
    firstDateRequired: '请选择第一节课日期',
    startTimeRequired: '请选择开始时间',
    endTimeRequired: '请选择结束时间',
    totalSessionsRequired: '请输入总节数',
    capacityRequired: '请输入班级容量',
    descPlaceholder: '请输入班级描述',
    datePlaceholder: '请选择日期',
    timePlaceholder: '请选择时间',
    capacityPlaceholder: '请输入容量',
    details: '班级详情',
    students: '班级学生 ({{count}}人)',
    noStudents: '暂无学生',
    removeStudentConfirm: '确定要将 {{name}} 移出班级吗？',
    removeStudentSuccess: '已将 {{name}} 从班级中移除',
    removeStudentFailed: '移出学生失败',
    removeFromClass: '移出班级',
    fetchFailed: '获取数据失败',
    fetchStudentsFailed: '获取班级学生失败',
    viewAttendance: '查看出勤',
    selectSession: '选择节次 — {{name}}',
    session: '第 {{index}} 节',
    sessionPast: '已上课',
    sessionFuture: '即将上课',
    rosterTitle: '出勤名单 — {{name}} {{date}}',
    attending: '✅ 预计出席（{{count}} 人）',
    absent: '❌ 已请假（{{count}} 人）',
    makeup: '🔄 补课插班（{{count}} 人）',
    attendanceSummary:
      '预计出席 {{attending}} 人 | 请假 {{absent}} 人 | 补课插班 {{makeup}} 人',
    sendToTeacher: '发送给老师',
    sendEmailConfirmTitle: '确认发送出勤表邮件',
    sendEmailConfirmContent:
      '将发送 {{date}} 课堂出勤表邮件给班级老师：{{teacher}}，确认继续吗？',
    sendEmailConfirmOk: '确认发送',
    sendEmailSuccess: '出勤表邮件已发送给老师',
    sendEmailFailed: '发送失败，请稍后重试',
    queryFailed: '查询失败，请稍后重试',
    printTitle: '课堂出勤名单',
    noAbsenceRecords: '无请假记录',
    studentName: '姓名',
    studentGrade: '年级',
    studentOriginClass: '原班级',
    colNotes: '备注',
    makeupSuffix: '[补课]',
    rosterInfo:
      '班级：{{name}} | 日期：{{date}}（{{day}}） | 时间：{{start}}-{{end}}',
    rosterSummary:
      '预计出席 {{attending}} 人 | 请假 {{absent}} 人 | 补课插班 {{makeup}} 人',
    timeLabel: '时间：',
    attendingLabel: '预计出席',
    absentLabel: '请假',
    makeupLabel: '补课插班',
    peopleUnit: '人',
  },
  students: {
    title: '学生管理',
    subtitle: '当前共有 {{count}} 名学生',
    addStudent: '添加学生',
    editStudent: '编辑学生',
    searchPlaceholder: '搜索学生...',
    studentNumber: '学号',
    name: '姓名',
    grade: '年级',
    class: '班级',
    status: '状态',
    parent: '家长',
    action: '操作',
    statusActive: '在读',
    statusInactive: '休学',
    statusGraduated: '已毕业',
    unassigned: '未分配',
    deleteConfirm: '确定要删除这个学生吗？',
    deleteSuccess: '学生删除成功',
    deleteFailed: '删除学生失败',
    saveSuccess: '学生信息更新成功',
    addSuccess: '学生添加成功',
    saveFailed: '保存学生信息失败',
    fetchFailed: '获取数据失败',
    noData: '暂无学生数据',
    namePlaceholder: '请输入学生姓名',
    nameRequired: '请输入学生姓名',
    gradeRequired: '请选择年级',
    gradePlaceholder: '请选择年级',
    classRequired: '请选择班级',
    classPlaceholder: '请选择班级',
    statusRequired: '请选择状态',
    statusPlaceholder: '请选择状态',
    parentRequired: '请选择家长',
    parentPlaceholder: '请选择家长',
  },
  teachers: {
    title: '老师管理',
    subtitle: '当前共有 {{count}} 位老师',
    addTeacher: '添加老师',
    editTeacher: '编辑老师',
    searchPlaceholder: '搜索老师...',
    name: '姓名',
    email: '邮箱',
    phone: '联系方式',
    role: '角色',
    createdAt: '创建时间',
    action: '操作',
    details: '老师详情',
    avatar: '头像',
    lastUpdated: '最后更新',
    deleteConfirm: '确定要删除这位老师吗？',
    deleteWarning: '删除后，该老师将无法登录系统',
    deleteSuccess: '老师删除成功',
    deleteFailed: '删除老师失败',
    saveSuccess: '老师信息更新成功',
    addSuccess: '老师添加成功',
    saveFailed: '保存老师信息失败',
    fetchFailed: '获取教师列表失败',
    accessDenied: '访问被拒绝',
    accessDeniedMsg: '您没有权限访问老师管理页面。',
    namePlaceholder: '请输入老师姓名',
    nameRequired: '请输入老师姓名',
    nameMin: '姓名至少2个字符',
    emailPlaceholder: '请输入邮箱地址',
    emailRequired: '请输入邮箱地址',
    emailInvalid: '请输入有效的邮箱地址',
    phonePlaceholder: '请输入手机号',
    phoneInvalid: '请输入有效的手机号',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    passwordMin: '密码长度至少6位',
    passwordHint: '留空表示不修改密码',
    roleTeacher: '老师',
    roleAdmin: '管理员',
    notSet: '未设置',
    password: '密码',
  },
  campuses: {
    title: '校区管理',
    subtitle: '管理瀚文书院的各个校区信息，包括地址、联系人和电话',
    addCampus: '添加校区',
    editCampus: '编辑校区',
    searchPlaceholder: '搜索校区名称、地址或联系人...',
    name: '校区名称',
    address: '地址',
    contactPerson: '联系人',
    phone: '联系电话',
    status: '状态',
    action: '操作',
    statusActive: '活跃',
    statusInactive: '停用',
    noDesc: '暂无描述',
    details: '校区详情',
    description: '校区描述',
    deleteConfirm: '确定要删除这个校区吗？',
    deleteSuccess: '校区删除成功',
    deleteFailed: '删除校区失败',
    saveSuccess: '校区信息更新成功',
    addSuccess: '校区添加成功',
    saveFailed: '保存校区信息失败',
    fetchFailed: '获取校区列表失败',
    accessDenied: '访问被拒绝',
    accessDeniedMsg: '您没有权限访问校区管理页面。',
    namePlaceholder: '例如：Baulkham Hills校区',
    addressPlaceholder: '请输入完整的校区地址',
    phonePlaceholder: '例如：(02) 9876 5432',
    contactPlaceholder: '例如：张校长',
    descPlaceholder: '请输入校区描述信息（可选）',
  },
  absences: {
    title: '请假管理',
    submitAbsence: '提交请假',
    searchPlaceholder: '搜索学生或班级...',
    allStatus: '全部状态',
    pending: '待审核',
    approved: '已批准',
    rejected: '已驳回',
    student: '学生',
    date: '请假日期',
    reason: '请假原因',
    submittedAt: '提交时间',
    status: '状态',
    view: '查看',
    review: '审核',
    deleteConfirm: '确定要删除这条请假记录吗？',
    deleteSuccess: '请假记录删除成功',
    deleteFailed: '删除请假记录失败',
    saveSuccess: '请假记录更新成功',
    addSuccess: '请假记录提交成功',
    saveFailed: '提交请假记录失败',
    fetchFailed: '获取数据失败',
    noMatch: '没有找到匹配的请假记录',
    noRecords: '暂无请假记录',
    noMatchHint: '请尝试其他搜索条件或清除筛选',
    noRecordsHint: '点击"提交请假"按钮添加第一条记录',
    clearFilter: '清除筛选',
    detailTitle: '请假记录详情',
    submitTitle: '提交请假记录',
    studentName: '学生姓名',
    studentRequired: '请选择学生',
    dateRequired: '请选择请假日期',
    reasonRequired: '请选择请假原因',
    reasonSick: '生病',
    reasonFamily: '家庭活动',
    reasonSchool: '学校活动',
    reasonOther: '其他',
    detailDesc: '详细说明',
    detailPlaceholder: '请详细说明请假原因...',
    currentStatus: '当前状态',
    reviewer: '审核人',
    reviewTime: '审核时间',
    reviewComment: '审核意见',
    reviewTitle: '审核请假记录',
    reviewDecision: '审核决定',
    reviewDecisionRequired: '请选择审核决定',
    approve: '批准',
    reject: '驳回',
    reviewCommentPlaceholder: '请输入审核意见...',
    class: '班级',
    none: '无',
  },
  makeup: {
    title: '补课管理',
    classesTab: '补课班',
    bookingsTab: '我的预约',
    create: '创建',
    searchPlaceholder: '搜索补课班...',
    scheduled: '待上课',
    completed: '已结束',
    cancelled: '已取消',
    booked: '已预约',
    attended: '已上课',
    absent: '请假',
    allStatus: '全部',
    className: '补课班名称',
    classTime: '上课时间',
    teacherLocation: '教师/地点',
    slots: '名额',
    bookedCount: '已预约',
    capacity: '容量',
    remaining: '剩余 {{count}} 个名额',
    full: '已满额',
    student: '学生',
    makeupClass: '补课班',
    bookingTime: '预约时间',
    attendance: '出勤',
    attended2: '已出勤',
    cancelConfirm: '确定要取消这个预约吗？',
    cancelSuccess: '预约取消成功',
    cancelFailed: '取消预约失败',
    deleteConfirm: '确定要删除这个补课班吗？',
    deleteSuccess: '补课班删除成功',
    deleteFailed: '删除补课班失败',
    saveSuccess: '补课班信息更新成功',
    addSuccess: '补课班创建成功',
    saveFailed: '提交补课班失败',
    bookSuccess: '预约成功',
    bookFailed: '预约失败',
    fetchFailed: '获取数据失败',
    noMatch: '没有找到匹配的补课班',
    noClasses: '暂无补课班',
    noMatchHint: '请尝试其他搜索条件或清除筛选',
    noClassesHint: '点击"创建"按钮添加第一个补课班',
    clearFilter: '清除筛选',
    noBookings: '暂无预约记录',
    noBookingsHint: '请在补课班页面预约可用的补课班',
    upcomingClasses: '即将开始的补课班',
    bookNow: '立即预约',
    editTitle: '编辑补课班',
    createTitle: '创建补课班',
    classNamePlaceholder: '请输入补课班名称',
    contentDesc: '补课内容描述',
    contentPlaceholder: '请输入补课内容描述...',
    makeupDate: '补课日期',
    dateRequired: '请选择补课日期',
    makeupTime: '补课时间',
    timeRequired: '请输入补课时间',
    timePlaceholder: '例如：14:00-16:00',
    instructor: '授课教师',
    instructorRequired: '请输入授课教师',
    location: '上课地点',
    locationRequired: '请输入上课地点',
    availableSlots: '可用名额',
    slotsRequired: '请输入可用名额',
    bookTitle: '预约补课班',
    bookDate: '补课日期',
    bookTime: '补课时间',
    bookInstructor: '授课教师',
    bookLocation: '上课地点',
    bookRemaining: '剩余名额',
    bookUnit: '个',
    studentName: '学生姓名',
    studentRequired: '请选择学生',
    noClass: '未分配班级',
    notesPlaceholder: '请输入备注...',
    pendingMakeup: '待上课补课班',
    myBookings: '我的预约',
    availableSlotsTitle: '可用名额',
  },
  auditLog: {
    title: '操作日志',
    total: '共 {{count}} 条记录',
    backup: '立即备份',
    actionType: '操作类型',
    resourceType: '资源类型',
    create: '新增',
    update: '修改',
    delete: '删除',
    sendEmail: '发送邮件',
    changePassword: '修改密码',
    bulkImport: '批量导入',
    resourceClass: '班级',
    resourceStudent: '学生',
    resourceTeacher: '老师',
    resourceCampus: '校区',
    resourceAbsence: '请假',
    resourceMakeup: '补课预约',
    time: '时间',
    actor: '操作人',
    action: '操作',
    resource: '资源类型',
    objectName: '对象名称',
    detail: '详情',
    viewDetail: '查看',
    detailTitle: '操作详情',
    field: '字段',
    before: '修改前',
    after: '修改后',
    ip: 'IP',
    actorRole: '操作人角色',
  },
  profile: {
    title: '个人信息',
    edit: '编辑',
    name: '姓名',
    namePlaceholder: '请输入姓名',
    email: '邮箱',
    emailHint: '邮箱是唯一识别符，不可修改',
    phone: '手机号码',
    phonePlaceholder: '请输入手机号码',
    phoneInvalid: '手机号码格式不正确',
    saveChanges: '保存修改',
    changePassword: '修改密码',
    passwordHint: '定期更换密码可以保护账户安全',
    currentPassword: '当前密码',
    currentPasswordPlaceholder: '请输入当前密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    passwordRule: '密码长度至少6位，且必须包含字母和数字',
    confirmPassword: '确认新密码',
    confirmPasswordPlaceholder: '请确认新密码',
    confirmPasswordAgain: '再次输入新密码',
    passwordMismatch: '两次输入的密码不一致',
    relatedStudents: '关联学生',
    logout: '退出登录',
    registeredAt: '注册',
    lastLogin: '登录',
    neverLoggedIn: '从未登录',
    fetchFailed: '获取用户数据失败',
    updateSuccess: '个人信息更新成功',
    updateFailed: '更新个人信息失败',
    passwordSuccess: '密码修改成功',
    passwordFailed: '修改密码失败',
    loading: '加载中...',
    loadFailed: '无法加载用户数据',
    userNotLoaded: '用户数据未加载',
    unassignedClass: '未分配班级',
    statusActive: '在读',
    reset: '重置',
    versionInfo: '版本信息',
    frontend: '前端',
    backend: '后端',
  },
  parent: {
    homeTitle: '你好，{{name}}！',
    homeSubtitle: '欢迎回来，查看孩子的学习安排',
    pendingMakeup: '待补课程',
    noPendingMakeup: '暂无待补课程',
    pendingBook: '待预约',
    book: '预约',
    originalClass: '原课：{{date}}',
    validUntil: '有效期至 {{date}}（剩{{days}}天）',
    upcomingClasses: '即将上课',
    recentTwoWeeks: '近四周',
    allSessions: '全部课次',
    noUpcoming: '近两周暂无课程安排',
    makeupTag: '补课',
    absenceTag: '已请假',
    makeupReason: '补课原因：{{className}} 请假补课',
    leaveTag: '请假',
    allSessionsTitle: '全部课次安排',
    classInfo: '共 {{total}} 节 · {{schedule}} · {{campus}}',
    sessionLabel: '#',
    sessionAbsent: '已请假',
    sessionToday: '今天',
    sessionDone: '已上课',
    sessionPending: '未上课',
    bookModalTitle: '预约补课 · {{name}}',
    bookMakeup: '预约补课',
    reselect: '重新选择',
    confirmBook: '确认预约',
    originalInfo: '原课：{{className}} · {{date}} · 补课有效期至 {{deadline}}',
    levelFilter: '级别筛选',
    loadingSlots: '加载中…',
    slotsCount: '{{count}} 个可用时段',
    sameLevelOnly: '仅同级别',
    showAllLevels: '显示所有级别',
    noSlots: '暂无可预约的时段',
    selectedSlot: '已选：{{className}} · {{date}} {{time}} · {{campus}}',
    selectedHint: '点击"确认预约"完成预约，或点击时段重新选择。',
    submitLeave: '申请请假',
    course: '课程',
    reasonSick: '身体不适',
    reasonFamily: '家庭事务',
    reasonSchool: '学校事务',
    reasonOther: '其他原因',
    reasonRequired: '请选择请假原因',
    detailDesc: '详细说明',
    detailPlaceholder: '请详细说明请假原因...',
    bookConfirmTitle: '确认预约补课',
    bookConfirmContent:
      '预约成功后将自动发送邮件通知给班级老师：{{teacher}} 和您本人，确认继续吗？',
    bookConfirmOk: '确认预约',
    bookSuccess: '预约成功！确认邮件已发送',
    bookFailed: '预约失败',
    leaveConfirmTitle: '确认提交请假申请',
    leaveConfirmContent:
      '提交后将自动发送邮件通知给班级老师：{{teacher}} 和您本人，确认继续吗？',
    leaveConfirmOk: '确认提交',
    leaveSuccess: '请假申请已提交',
    leaveFailed: '请假失败',
    fetchFailed: '获取数据失败',
    fetchSlotsFailed: '获取可用时段失败',
    layoutTitle: '瀚文书院',
    layoutSubtitle: '瀚文书院管理系统',
    layoutParent: '家长',
    myChildren: '我的孩子',
    childrenCount: '位',
    noChildren: '暂无孩子信息',
    noName: '未命名',
    noChineseName: '未填写中文名',
    noBirthday: '未填写生日',
    noSchool: '未填写学校',
    profileChangePassword: '修改密码',
    profileCurrentPassword: '当前密码',
    profileCurrentRequired: '请输入当前密码',
    profileNewPassword: '新密码',
    profileNewHint: '至少6位，需包含字母和数字',
    profileNewRequired: '请输入新密码',
    profilePasswordMin: '密码至少6位',
    profilePasswordLetterNumber: '密码需包含字母和数字',
    profileConfirmPassword: '确认新密码',
    profileConfirmRequired: '请确认新密码',
    profilePasswordMismatch: '两次输入的密码不一致',
    profileConfirmAgain: '再次输入新密码',
    profileSubmit: '修改密码',
    profileLogout: '退出登录',
    profileChangeSuccess: '密码修改成功',
    profileChangeFailed: '修改密码失败',
    student: '学生',
    date: '日期',
  },
  notFound: {
    title: '页面不存在',
    message: '抱歉，您访问的页面不存在',
    backHome: '返回首页',
    contactHint: '如果您认为这是一个错误，请联系班级老师',
  },
  header: {
    title: '瀚文书院',
    subtitle: '瀚文书院管理系统',
  },
  weekdays: {
    mon: '周一',
    tue: '周二',
    wed: '周三',
    thu: '周四',
    fri: '周五',
    sat: '周六',
    sun: '周日',
  },
  grades: {
    grade1: '一年级',
    grade2: '二年级',
    grade3: '三年级',
    grade4: '四年级',
    grade5: '五年级',
    grade6: '六年级',
  },
  absenceCard: {
    pending: '待审核',
    approved: '已批准',
    rejected: '已拒绝',
    sick: '生病',
    personalLeave: '事假',
    schoolActivity: '学校活动',
    other: '其他',
    applicationTime: '申请时间',
    approve: '批准',
    reject: '拒绝',
  },
  makeupCard: {
    inProgress: '进行中',
    completed: '已完成',
    cancelled: '已取消',
    slots: '名额',
    full: '已满',
    remaining: '剩余',
    book: '预约',
  },
  studentCard: {
    active: '在读',
    inactive: '休学',
    graduated: '已毕业',
  },
  guide: {
    pageTitle: '家长使用说明',
    pageSubtitle: '瀚文书院管理系统 · 请假 & 预约补课指南',
    sectionLogin: '🔐 登录系统',
    sectionAbsence: '🙋 如何为孩子请假',
    sectionMakeup: '📅 如何预约补课',
    step1Title: '输入账号密码登录',
    step1Text:
      '用班级老师提供的邮箱地址和密码登录系统，登录后自动跳转到家长首页。',
    step1Tip: '如忘记密码，请联系班级老师重置。',
    step2Title: '在首页找到需要请假的课程',
    step2Text:
      '首页显示孩子近两周的课程安排，每个课程卡片右侧有橙色的「请假」按钮，点击后填写请假原因提交即可。',
    step3Title: '请假成功后，待补课程自动出现',
    step3Text1: '请假成功后，该课程显示「已请假」标签。',
    step3Text2:
      '页面顶部「待补课程」区域会出现待补记录，显示原课日期和补课有效期，点击「预约」即可开始预约补课。',
    step4Title: '选择合适的补课时间',
    step4Text: '弹窗列出所有可用时段，每条显示：',
    step4Item1: '班级名称和级别',
    step4Item2: '上课日期、时间和校区',
    step4Item3: '任课老师和剩余名额',
    step4Item4: '「推荐」标签表示与原班同级别、同校区、同老师',
    step4Confirm:
      '点击时段选中（高亮显示），底部显示已选信息，确认后点击「确认预约」完成。如需更换，点击「重新选择」。',
    tipsTitle: '💡 温馨提示',
    tip1: '补课预约须在有效期内完成，过期后无法使用',
    tip2: '补课名额有限，建议尽早预约',
    tip3: '如有疑问，请联系班级老师',
    backToLogin: '← 返回登录页',
  },
  forgotPassword: {
    title: '忘记密码',
    subtitle: '通过邮箱验证码重置密码',
    backToLogin: '返回登录',
    stepEmail: '输入邮箱',
    stepCode: '验证身份',
    stepPassword: '重置密码',
    sendCode: '发送验证码',
    sendFailed: '验证码发送失败',
    codeSentTo: '验证码已发送至：',
    codeRequired: '请输入验证码',
    codeLength: '验证码为6位数字',
    codePlaceholder: '请输入6位验证码',
    verifyCode: '验证验证码',
    verifyFailed: '验证码验证失败',
    resendAfter: '{{seconds}}秒后可重发',
    resendCode: '重新发送验证码',
    passwordRequired: '请输入新密码',
    passwordMin: '密码长度至少6位',
    newPasswordPlaceholder: '请输入新密码',
    confirmRequired: '请确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    passwordMismatch: '两次输入的密码不一致',
    resetPassword: '重置密码',
    resetFailed: '密码重置失败',
    successTitle: '密码重置成功',
    successSubtitle: '请使用新密码登录系统',
  },
  studentEdit: {
    title: '编辑学生信息',
    name: '英文名',
    nameRequired: '英文名',
    namePlaceholder: '请输入英文名',
    chineseName: '中文名',
    chineseNamePlaceholder: '请输入中文名',
    birthday: '生日',
    birthdayPlaceholder: '请选择生日',
    school: '学校',
    schoolPlaceholder: '请输入学校名称',
    notes: '备注',
    notesPlaceholder: '请输入备注信息',
    saveSuccess: '学生信息更新成功',
    saveFailed: '更新学生信息失败',
  },
  dataManagement: {
    title: '数据管理',
    description: '批量导入/导出学生、家长、班级等数据',
    importStudents: '批量导入学生',
    importStudentsDesc: '通过 CSV 文件批量导入学生和家长信息；班级和年级可留空（班级留空将归入"未分班"）',
    downloadTemplate: '下载模板',
    clickOrDrag: '点击或拖拽 CSV 文件到此处',
    csvFormatHint: '仅支持 CSV 格式文件',
    dryRun: '试运行（不实际保存）',
    dryRunComplete: '试运行完成',
    importComplete: '导入完成',
    importFailed: '导入失败',
    importing: '导入中...',
    import: '开始导入',
    selectFileFirst: '请先选择文件',
    dryRunResult: '试运行结果',
    importResult: '导入结果',
    importErrors: '导入错误',
    importWarnings: '导入警告',
    newParentsPasswordTitle: '新家长默认密码（请转告家长）',
    newParentsPasswordHint: '以下家长为本次导入新建，默认密码为系统生成。请老师告知家长，家长首次登录后建议修改密码。',
    defaultPassword: '默认密码',
    parentsCreated: '新建家长',
    parentsSkipped: '跳过家长',
    studentsCreated: '新建学生',
    studentsSkipped: '跳过学生',
    exportStudents: '导出学生数据',
    exportStudentsDesc: '导出所有学生信息为 CSV 文件',
    exportClasses: '导出班级数据',
    exportClassesDesc: '导出所有班级信息为 CSV 文件',
    exportParents: '导出家长数据',
    exportParentsDesc: '导出所有家长信息为 CSV 文件',
    userManagement: '用户信息管理',
    userManagementDesc: '修改用户（家长/老师）的基本信息，支持角色转换',
    searchUser: '搜索用户',
    searchPlaceholder: '输入家长/老师的姓名、邮箱或电话...',
    searchByStudentPlaceholder: '输入学生姓名搜索家长...',
    searchBtn: '搜索',
    searchMinLength: '搜索关键词至少 2 个字符',
    noUserFound: '未找到匹配的用户',
    editUser: '编辑用户',
    saveSuccess: '用户信息更新成功',
    saveFailed: '保存用户信息失败',
    fetchFailed: '获取用户信息失败',
    roleChangeWarning: '将老师角色修改为家长前，需确保该老师不负责任何班级',
    studentsCountWarning:
      '将家长角色修改为老师前，需确保该家长名下没有在读学生',
    classesCount: '负责班级数',
    studentsCount: '名下学生数',
    roleParent: '家长',
    roleTeacher: '老师',
    roleAdmin: '管理员',
    importFileUpload: 'CSV 文件上传',
    importPasteText: '文本粘贴导入',
    pasteFormatHint: '每行一个学生+家长记录。格式：班级名,学生姓名,年级,家长姓名,家长邮箱,家长电话。班级、年级可留空（班级留空 = 未分班）',
    copyImportFormat: '复制导入格式',
    copyFormatSuccess: '已复制导入格式表头',
    copyFormatFailed: '复制失败，请手动复制',
    pasteStudentInfo: '请粘贴学生和家长信息',
  },
  chatBot: {
    title: 'AI 助手',
    placeholder: '输入消息...',
    send: '发送',
    welcome: '你好！我是瀚文书院 AI 助手，有什么可以帮你的？',
    clearConversation: '清空对话',
    thinking: '思考中...',
    error: '回复失败，请稍后重试',
  },
  landing: {
    hero: {
      title: '爱学习，爱中文',
      cta: '咨询报名',
    },
    services: {
      title: '我们的课程',
      subtitle: '为各年龄段提供全面的中文课程',
      mandarinTitle: 'Mandarin Lessons',
      mandarinSubtitle: '综合普通话课程',
      mandarinDesc: 'K-12 综合普通话课程，从基础到高级，全面提升听说读写能力',
      eventsTitle: 'Community Events',
      eventsSubtitle: '文化节庆与社区活动',
      eventsDesc: '中国文化年度聚会，庆祝传统节日，体验中华文化魅力',
      learnMore: '了解更多 →',
    },
    advantages: {
      title: '为什么选择瀚文',
      intro: '瀚文中文社区语言学校专注于小班互动式普通话教学，通过生动活泼的教学方法激发学生的学习热情，帮助他们在日常生活中自信地使用中文。',
      story: '瀚文书院创立于 2019 年 3 月 25 日，源于三位年轻妈妈对中文教育的执着初心。六年来，我们从最初约 20 名学生，发展成为在悉尼 Hills District 拥有四个校区、约 250 名学生的蓬勃学校（截至 2025 年第三学期）。我们为每位学生的热情与进步深感自豪，也期待更多学生加入，体验我们专业优质的教学。',
      vision: '我们的愿景是成为领先的中文教育与文化传播机构，培养自信、具有文化认同感、并为中华文化感到自豪的国际化人才。',
      introImageAlt: '学生们在互动式中文课堂上学习',
      highlight1: '20 → 250+',
      highlight1Label: '学生人数',
      highlight2: '4',
      highlight2Label: '校区',
      highlight3: '2019',
      highlight3Label: '创立年份',
      specializationTitle: 'Specialization',
      specializationSubtitle: '专注中文教学',
      specializationDesc: '我们专注于中文教育，针对海外学生的特点开发高效的教学方法，帮助他们真正掌握中文听说读写。',
      teachersTitle: 'Professional Teachers',
      teachersSubtitle: '专业教师团队',
      teachersDesc: '我们的教师持有澳洲社区语言教学认证，拥有多年教学经验，致力于培养学生的语言发展能力和文化认同。',
      smallClassTitle: 'Small Classes',
      smallClassSubtitle: '小班制教学',
      smallClassDesc: '标准每班 10 人，确保因材施教。我们根据每位学生的水平和学习风格提供个性化指导。',
      communityTitle: 'Community Engagement',
      communitySubtitle: '社区参与',
      communityDesc: '课堂之外，我们通过文化节庆、中文图书馆和阅读挑战赛，打造充满活力的学习社区。',
    },
    teachers: {
      title: '教师团队',
      subtitle: '我们的教师团队资质优秀，热爱学生，热爱中华文化传播。每位老师都有独特的专长和对教学的热忱。',
      yearsSuffix: '年教学经验',
      items: [
        { name: 'Jessica Zhang', exp: '20+', edu: ['首都师范大学英语教学学士', '悉尼大学社区语言教学认证', 'HBA 学习中心 Cert IV 培训与评估'], tagline: '多才多艺的教育者，善于与不同语言背景的学生建立联系、有效教学。' },
        { name: 'Lucy Yang', exp: '7+', edu: ['澳大利亚天主教大学小学教学硕士', '悉尼大学社区语言教学认证', '清华大学计算机科学硕士'], tagline: '擅长教授不同语言背景的学生，中英文教学俱佳。' },
        { name: 'Maggie Zhang', exp: '8+', edu: ['悉尼大学社区语言教学高级认证', '厦门大学会计学学士'], tagline: '充满热情的教育者，为所有学生营造积极投入的学习氛围。' },
        { name: 'Lisa Yuan', exp: '6+', edu: ['悉尼大学社区语言教学高级认证', '新南威尔士大学专业会计硕士'], tagline: '充满激情的教师，激发学生对中文文化和知识的热爱。' },
        { name: 'Queenie Li', exp: '7+', edu: ['山西大学汉语国际教育硕士', '澳大利亚托伦斯大学 MBA'], tagline: '出色的教育者，以富有感染力的课程激发学生成长与进步。' },
        { name: 'Eva Xu', exp: '4+', edu: ['悉尼大学社区语言教学认证', '湖南大学工商管理学士', '悉尼大学会计学硕士'], tagline: '友善亲切的老师，营造积极愉快的学习环境。' },
        { name: 'Caroline Liang', exp: '3+', edu: ['环境科学学士', '悉尼大学社区语言教学认证'], tagline: '专注中文背景学生的教学，细心负责。' },
        { name: 'Fiona Zhao', exp: '6+', edu: ['RMIT 大学幼儿教育研究生文凭', '华南理工大学英语学士'], tagline: '富有创意和热情，擅长教授不同语言背景的学生。' },
        { name: 'Grace Xie', exp: '6+', edu: ['温州大学小学教育学士'], tagline: '专注中文背景学生的教学，温暖耐心。' },
        { name: 'Jamie Jiang', exp: '14+', edu: ['北京体育大学教育学硕士', '悉尼大学社区语言教学认证'], tagline: '富有创意和热情，擅长教授不同语言背景的学生。' },
        { name: 'Nicole Liu', exp: '4+', edu: ['幼儿教育与保育文凭', '悉尼大学社区语言教学认证'], tagline: '擅长教授中文背景与非中文背景的学生。' },
      ],
    },
    gallery: {
      title: '瀚文剪影',
      subtitle: '看看我们社区的精彩瞬间',
    },
    promo: {
      alt: '中秋活动通知',
      closeAria: '关闭广告',
      dontShowAgain: '下次不再显示',
    },
    programs: {
      mandarin: {
        bannerTitle: '中文课程',
        intro1: '在瀚文书院，我们的中文课程面向 K-12 所有语言水平的学生。从零基础启蒙到高级提高，我们提供系统化的学习路径，全方位培养听、说、读、写综合语言能力。',
        intro2: '我们的课程体系专为海外成长环境下的中文学习者量身定制。在强化日常实用交流的同时，帮助学生打下扎实的汉字、语法与文化理解基础。',
        intro3: '采用精品小班教学（每班最多 10 人），确保经验丰富的教师能够关注到每一位学生，让孩子按自己的节奏稳步进步，同时保持学习的挑战性与参与感。',
        intro4: '我们将传统教材学习与丰富有趣的互动活动相结合——涵盖情境故事、角色扮演、文化歌曲及数字化教学工具，打造生动高效的课堂，持续激发孩子的学习热情。',
        intro5: '无论您的孩子是刚刚开启中文学习之旅，还是准备挑战高级水平，我们的课程都能提供坚实的专业支持、优质资源与全方位指导。',
        featuresTitle: '教学特色',
        cta: '咨询报名',
      },
      events: {
        bannerTitle: '社区活动',
        intro1: '在瀚文，学习远不止于课堂。我们通过丰富多彩的社区活动，将学生、家庭与广大社区紧密连接在一起，全年共同庆祝中华传统节日与文化。',
        intro2: '从热闹非凡的传统节庆到趣味十足的教育工作坊，这些聚会为孩子们提供了深度文化沉浸与社区联结的宝贵机会。',
        festivalsTitle: '年度节日庆典',
        springFestival: 'Chinese New Year',
        springFestivalZh: '春节',
        springFestivalDesc: '我们全年最盛大的庆典，包含精彩的舞狮表演、书法体验、手工剪纸与传统美食尝鲜。',
        dragonBoat: 'Dragon Boat Festival',
        dragonBoatZh: '端午节',
        dragonBoatDesc: '带领学生了解屈原的故事、亲手学包粽子，并参与生动有趣的文化故事会。',
        midAutumn: 'Mid-Autumn Festival',
        midAutumnZh: '中秋节',
        midAutumnDesc: '品尝月饼、制作灯笼、赏月吟诗，在温馨的氛围中共度中秋佳节。',
        communityTitle: '社区文化项目',
        communityItem1: '传统文化与艺术工作坊',
        communityItem2: '中文社区图书馆',
        communityItem3: '阅读挑战赛 & 趣味阅读 Bingo',
        photosTitle: '精彩瞬间',
        cta: '咨询报名',
      },
    },
    locations: {
      title: '校区地址',
      subtitle: '四个校区遍布悉尼 Hills District',
      crestwood: 'Crestwood校区',
      crestwoodVenue: 'Crestwood Community Centre',
      crestwoodAddr: 'Corner of Crestwood Dr and Conway Ct, Baulkham Hills 2153',
      baulkhamHills: 'BHHS校区',
      baulkhamHillsVenue: 'Baulkham Hills High School',
      baulkhamHillsAddr: '419A Windsor Rd, Baulkham Hills NSW 2153',
      kellyville: 'Kellyville校区',
      kellyvilleVenue: 'Wrights Road Community Centre',
      kellyvilleAddr: 'Corner Harrington Avenue and Wrights Road, Castle Hill 2155',
      glenwood: 'Glenwood校区',
      glenwoodVenue: 'Glenwood Community Hub',
      glenwoodAddr: '72 Glenwood Park Dr, Glenwood NSW 2768',
    },
    // about: {
    //   title: '关于我们',
    //   description:
    //     '瀚文书院致力于推广中文教育和中华文化，为 K-12 学生提供优质的普通话课程。我们拥有经验丰富的教师团队，在悉尼多个校区开展教学，帮助学生建立扎实的语言基础，培养对中华文化的热爱。',
    // },
    nav: {
      home: '首页',
      timetable: '课程表',
      about: '关于我们',
      faq: '常见问题',
      manage: '管理系统',
    },
    faq: {
      title: '常见问题解答',
      subtitle: '查找关于瀚文中文学校的常见问题答案',
      categories: {
        about: '关于学校',
        curriculum: '课程与学习目标',
        tuition: '学费',
        enrolment: '报名',
        culture: '文化与社区',
        teachers: '师资力量',
        contact: '联系我们',
      },
      about: {
        q1: '瀚文中文社区语言学校是什么样的学校？',
        a1: '瀚文是一所位于悉尼Hills区Baulkham Hills的社区语言学校，专注于以小班形式教授中文（普通话）。学校采用生动灵活的教学方法，致力于让学生积极投入、热爱学习中文，并帮助他们在日常生活中运用中文。',
        q2: '学校校区在哪里？',
        a2: '瀚文目前在四个校区开设课程：\n\n• Crestwood 校区 — Crestwood 社区中心，位于 Crestwood Drive 与 Conway Court 交界处，Baulkham Hills NSW 2153。\n上课时间：周一至周五 下午3:30–5:30；周六 上午9:00–中午12:00。\n\n• BHHS 校区 — Baulkham Hills High School，419A Windsor Road, Baulkham Hills NSW 2153。\n上课时间：周六 下午1:30–3:30 及 下午3:30–5:30。\n\n• Kellyville 校区 — Wrights Road 社区中心，位于 Harrington Avenue 与 Wrights Road 交界处，Castle Hill NSW 2155。\n上课时间：周日 下午4:00–6:00。\n\n• Glenwood 校区 — Glenwood 社区中心，72 Glenwood Park Drive, Glenwood NSW 2768。\n上课时间：周日下午1:30–3:30 及 下午3:30–5:30。',
        q3: '招收哪些年龄段的学生？',
        a3: '瀚文为幼儿园（K）至12年级（K–12）的孩子提供课程。此外，也通过小组课和网课的形式为成人学生提供教学，私人辅导可另行咨询安排。',
        q4: '是否招收非华裔家庭的学生？',
        a4: '是 — 瀚文书院有接收非华裔背景学生的班级。针对这些学生，学校会挑选适合他们需求的教材和教学方法，力求让学习中文成为一件轻松愉快的事。',
        q5: '除了中文，还教授其他语言吗？',
        a5: '不教授 — 瀚文只教授中文（普通话）。',
      },
      curriculum: {
        q1: '瀚文的教学目标是什么？',
        a1: '瀚文对中文能力的理解包括：\n\n• 流利地理解和说中文\n• 认识大量汉字，能阅读简单的短文\n• 理解汉字的结构和特点\n• 能书写一定数量的汉字，并能用拼音在电子设备上输入中文\n• 能用中文写简单的便条和短文\n• 了解中华文化',
        q2: '学生如何被分配到不同班级？',
        a2: '学生会根据年龄段和中文水平被分配到相应的班级，确保每位学生都能与年龄相近的同伴一起学习，并处于适合自己的学习水平，而不是"一刀切"的班级安排。',
        q3: '使用什么教材？',
        a3: '瀚文的核心教材是《人教版小学语文统编教材》，并结合学校自己老师们开发的、专为海外学生量身定制的教学材料。',
        q4: '班级规模有多大？',
        a4: '每班学生人数最多不超过12人，学校表示这有助于保证教学质量，并让学生获得个性化辅导。',
      },
      tuition: {
        q1: '学费是多少？',
        a1: '如果您想了解我们的学费，请发邮件至 admin@hanwenchinese.com。',
        q2: '学费如何收取？',
        a2: '学费按每两个学期一起收取：第一、二学期的学费在1月份收取，第三、四学期的学费在7月份收取。',
      },
      enrolment: {
        q1: '如何为孩子报名？',
        a1: '报名事宜由学校统一处理 — 如需报名咨询，请发邮件至 admin@hanwenchinese.com。',
        q2: '新生一般什么时候可以报名？',
        a2: '新生通常在第一学期和第三学期入学。',
        q3: '上课时间是怎样安排的？',
        a3: '瀚文在学期内提供中文课程。总体上课时间为：\n\n• 周一至周五\n下午 3:30 – 5:30\n\n• 周六\n上午 9:00 – 12:00\n下午 1:30 – 5:30\n\n• 周日\n下午 1:30 – 3:30\n下午 3:30 – 5:30\n下午 4:00 – 6:00',
      },
      culture: {
        q1: '瀚文除了语言课程还有其他活动吗？',
        a1: '有的 — 除了日常课程外，瀚文每年都会举办社区活动，让学生和家长们欢聚一堂，共同庆祝中国文化和一年的学习成果。这些活动也为学生提供了展示才艺的机会。',
        q2: '瀚文课程背后的整体理念是什么？',
        a2: '瀚文的目标不仅是培养学生听说读写中文的能力，更希望培养他们对学习的好奇心，以及与中华文化的情感联系。',
      },
      teachers: {
        q1: '由谁来授课？',
        a1: '瀚文的老师们经验丰富，善于营造温馨而充满乐趣的课堂氛围，致力于支持学生的全面发展。',
      },
      contact: {
        q1: '如何联系瀚文？',
        a1: '如需报名咨询，请发邮件至 admin@hanwenchinese.com。您也可以通过瀚文的 Facebook 主页（facebook.com/HanwenChinese）或学校网站，了解学费及最新学期课表等信息。',
      },
    },
    timetable: {
      title: '课程表',
      subtitle: '选择学期查看课程安排',
      term: '第 {{n}} 学期',
      day: '星期{{day}}',
      time: '时间',
      class: '班级',
      location: '地点',
    },
    footer: {
      brandName: '瀚文书院',
      tagline: '培养每一位学生对中文和中国文化的热爱',
      contact: '联系我们',
      social: '关注我们',
      email: 'admin@hanwenchinese.com',
    },
  },
};
